import styled from "styled-components";
export const Card = styled.div.attrs(props => ({
  border: props.bordered
}))`
  display: block;
  position: relative;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.48);
  ${props => props.theme.card.default};
  ${props => props.border && props.theme.card.bordered};
`;
export const CardBordered = styled(Card)`
  border-style: solid;
  box-shadow: none;
`;